<div class="dn-container">
  <h3 class="attachment-title">{{ 'report-section.title' | translate }}</h3>
  <div class="dn-card">
    <div class="dn-card-left">
      <div class="dn-file-icon">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#6C6C6C" stroke-width="1.5">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <path d="M14 2v6h6"></path>
        </svg>
      </div>
    </div>

    <div class="dn-card-middle">
      <div class="dn-card-title">{{ 'report-section.title' | translate }}</div>
      <div class="dn-card-subtitle">{{ 'report-section.description' | translate }}</div>
    </div>

    <div class="dn-card-right">
      <div class="dn-doc-right">
        <div class="dn-doc-actions">

          <button type="button" class="dn-more-button" (click)="toggleMenu()">
            <tui-icon icon="tuiIconMoreVertical" class="dn-more-icon"></tui-icon>
          </button>

          <div class="options-menu" *ngIf="showMenu" [@fadeInOut]>
            <ng-container *ngFor="let item of reportMenuActions">
              <div *ngIf="item.dividerBefore" class="divider"></div>
              <button type="button" class="option-item" [class.danger]="item.danger" (click)="item.action()">
                <tui-icon [icon]="item.icon" class="option-icon"></tui-icon>
                <span>{{ item.labelKey | translate }}</span>
              </button>
            </ng-container>
          </div>

        </div>
      </div>
    </div>
  </div>

</div>